import { Component } from 'react';

export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <pre style={{ whiteSpace: 'pre-wrap', padding: 20, color: 'red' }}>
          {this.state.error.stack || String(this.state.error)}
        </pre>
      );
    }
    return this.props.children;
  }
}
